const SquareServices = () => {
  return (
    <div className="container py-5">
      <div style={{ marginTop: 50 }}>
        <div id="square-appointments-widget">
          <iframe
            src="https://book.squareup.com/appointments/msuxoazw9z05vw/location/L8QRK1TAESYKK/services"
            style={{ width: "100%", height: "600px" }}
            title="Square Appointments"
          />
        </div>
      </div>
    </div>
  );
};
export default SquareServices;
